<template>
    <div class="relative">
        <div v-if="bottom" class="flex items-center space-x-3 w-6 h-6 cursor-pointer relative">
            <avatar @click="toggle"
                    :ava="user.ava"
                    :online="user.is_online && userStore.check()"
                    class="w-6 h-6"
            ></avatar>
            <svg-icon icon="heart-fill" class="w-2 h-2 text-pink-500 absolute -top-0.5 -right-0.5"
                      v-if="isValentineDayReadPeriod"></svg-icon>
        </div>

        <div v-else class="flex items-center space-x-1 cursor-pointer">
            <a :href="user.url" class="block relative">
                <avatar :ava="user.ava" :online="user.is_online && userStore.check()" class="w-6 h-6"></avatar>
                <svg-icon icon="heart-fill" class="w-2 h-2 text-pink-500 absolute -top-0.5 -right-0.5"
                          v-if="isValentineDayReadPeriod"></svg-icon>
            </a>
            <div @click="toggle"
                 class=" w-5 h-5 flex items-center cursor-pointer justify-center rounded-full hover:bg-orange/50">
                <svg-icon icon="chevron-down" class="w-3 h-3"></svg-icon>
            </div>
        </div>

        <div v-if="opened" v-click-outside="close"
             class="flex flex-col text-base w-52 z-50 absolute
             bg-white dark:bg-slate-900 shadow rounded-xl mt-3 space-y-1 p-2"

             :class="{
                'bottom-full right-0 -translate-y-3': bottom,
                'top-full right-0 ': !bottom
             }"
        >

            <a :href="user.url"
               class="cursor-pointer p-2 rounded hover:bg-gray-500/10 text-gray-700 dark:text-gray-300 py-1">
                Мой профиль
            </a>
            <a :href="user.url + '/drafts#feed'"
               class="cursor-pointer p-2 rounded hover:bg-gray-500/10 text-gray-700 dark:text-gray-300 py-1">
                Черновики
            </a>
            <a href="/u/settings"
               class="cursor-pointer p-2 rounded hover:bg-gray-500/10 text-gray-700 dark:text-gray-300 py-1">
                Настройки
            </a>
			<a v-if="isValentineDayReadPeriod" href="/u/valentines"
               class="cursor-pointer w-full flex gap-1 items-center p-2 rounded hover:bg-gray-500/10 text-gray-700 dark:text-gray-300 py-1">
                <div class="flex-1">Валентинки</div>
                <svg-icon icon="heart-fill" class="text-pink-500 w-3 h-3"></svg-icon>
            </a>
            <div @click="logout"
                 class="cursor-pointer p-2 rounded hover:bg-gray-500/10 text-gray-700 dark:text-gray-300 py-1">
                Выйти
            </div>

        </div>

    </div>
</template>
<script>
import Client from "../../js/modules/Client";
import User from "../../js/modules/User";
import Avatar from "../partials/Avatar.vue";

export default {
    components: {Avatar},
    props: [
        'bottom',
        'isValentineDayReadPeriod',
    ],
    data() {
        let userStore = new User();
        return {
            opened: false,
            userStore: userStore,
            user: userStore.data() ?? {},
        };
    },
    methods: {
        toggle() {
            this.opened = !this.opened;
        },
        close() {
            this.opened = false;
        },
        inlineBg(ava) {
            if (!ava) {
                return '';
            }
            return {backgroundImage: `url(${ava})`};
        },
        logout() {
            if (confirm('Точно выйти?')) {
                this.userStore.clear();
                Client.post('/logout')
                    .then(response => {
                        window.location.href = '/';
                    })
            }
        }
    }
}
</script>
